export default __webpack_public_path__ + "static/media/img5.e986e813.jpg";